import { Component, Inject, OnInit, inject, DestroyRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { Constants } from 'src/app/models/constants';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { MatDialog } from '@angular/material/dialog';
import { EnvironmentTableComponent } from '../environment-details/environment-table/environment-table.component';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { PathToLiveEnvironment } from 'src/app/models/blueprints/path-to-live-environment';
import { SolutionVersion } from 'src/app/models/service/solution-version';
import { Capability } from 'src/app/models/service/capability';
import { Instance } from 'src/app/models/instance/instance';
import { MatDialogData } from 'src/app/models/service/mat-dialog-data';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';


@Component({
  selector: 'app-infra-upgrade',
  templateUrl: './infra-upgrade.component.html',
  styleUrls: ['./infra-upgrade.component.scss'],
  standalone: false
})
export class InfraUpgradeComponent implements OnInit{
  @ViewChild(EnvironmentTableComponent) tableRef: EnvironmentTableComponent;

    title: string = translate('INFRA.INFRA_ALERT');
    infraLoaderMessage: string = translate('INFRA.INFRA_LOADER_MESSAGE');
    infraUpgradeMessage: string = translate('INFRA.INFRA_NO_UPGRADE');
    private destroyRef = inject(DestroyRef);
    dataLoading = true;
    Constants = Constants;
    dropdownLoader: boolean = false;
    versions: string[];
    selectedVersion: SolutionVersion | null = null;
    isVersionAvailable:boolean = false;
    showMinAlert = false;
    infraLoader = false;
    infraData: Capability[] | null = null;
    isNotInfraUpdate = false;
    preprodData: Instance | null = null;
 displayColumns = [
    {
      key: 'name',
      name: 'LEFT_SIDE_NAV.COMPONENTS',
      type: 'text',
      sortable: false,
      visible: true,
      disable: true
    },
    {
      key: 'version',
      name: 'SCHEDULE.VERSION',
      type: 'text',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'releaseVersion',
      name: 'INSTANCE_DETAILS.RELEASE_VERSION',
      type: 'text',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'componentType',
      name:  'COMPONENTS.COMPONENT_TYPE',
      type: 'text',
      visible: true,
      disable: false,
      sortable: true
    }
  ];
    abortDialogRef: MatDialogRef<ConfirmationDialogComponent>;

    constructor(@Inject(MAT_DIALOG_DATA) public data:MatDialogData, public matdialogRef: MatDialogRef<InfraUpgradeComponent>, public blueprintsService:BlueprintsService,
     public solutionsService:SolutionsService, public toastrService: CustomToastrService, public instanceService: InstancesService, private dialog: MatDialog,){}

  ngOnInit(): void {
      this.loadPreprodData();
      const preprodVersion = this.preprodData?.infraSolutionVersion;
      const [preMajor, preMinor, prePatch] = preprodVersion?.split('.')?.map(Number) || [];
          this.matdialogRef.backdropClick().subscribe(() => {
          if (this.infraLoader) {
            this.onCancelClick();
          } else {
            this.matdialogRef.close(false);
          }
        });
    if (this.data.dataLoaded) {
      this.dataLoading = false;
    }
    const parseVersionParts = (version: string | undefined): [number, number, number] => {
      if (!version) return [0, 0, 0];
      const parts = version.split('.').map(Number);
      return [parts[0] || 0, parts[1] || 0, parts[2] || 0];
    };
    this.solutionsService.getSolutionVersions(this.data.instance.solutionId).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
          if (data) {
            const instanceVersion = this.data.instance.infraSolutionVersion ? this.data.instance.infraSolutionVersion : this.data?.instance?.version;
            const [currentMajor, currentMinor, currentPatch] = parseVersionParts(instanceVersion);
            let filteredVersions: SolutionVersion[] = data
            .filter((item: SolutionVersion) => {
              const [major, minor, patch] = item.version.split('.').map(Number);
              const isGreaterThanCurrent =
              major === currentMajor &&
              minor === currentMinor &&
              patch > currentPatch;
              let isLessThanPreprod = true;
              if (this.data.instance.environment === PathToLiveEnvironment.LIVE && !(window.location.href.split('.')[0].split('/')[2] === 'preprod')) {
                isLessThanPreprod =
                  major === preMajor &&
                  minor === preMinor &&
                  patch <= prePatch;
              }
              return isGreaterThanCurrent && isLessThanPreprod;
            });

            // If the infra upgrade failed, add the current version to allow retry with the same version
            if (this.data.instance?.lastLifecycleOperation?.status === DeployStatus.FAILED && this.data.instance?.lastLifecycleOperation?.type === "infraUpdate") {
              const currentVersionObj = data.find((item: SolutionVersion) => item.version === instanceVersion);
              if (currentVersionObj && !filteredVersions.find(v => v.version === instanceVersion)) {
                filteredVersions.push(currentVersionObj);
              }
            }

            filteredVersions.sort((a: SolutionVersion, b: SolutionVersion) => {
            const patchA = Number(a.version.split('.')[2]);
            const patchB = Number(b.version.split('.')[2]);
            return patchA - patchB;
            });

            this.versions = filteredVersions as any;
            this.dropdownLoader = true;
            }
            },(error) => {
              this.handleError(error, translate('ERRORS.SERVICE_AVAILABILITY'));
      });
  }

  private handleError(error: any, title: string): void {
    let message: string;
    if (typeof error.message === 'string') {
      message = error.message;
    } else if (error) {
      message = error.error?.message || error?.errmsg || translate('SERVICE.INTERNAL_SERVER_ERROR');
    } else {
      message = translate('SERVICE.INTERNAL_SERVER_ERROR');
    }
    this.toastrService.errMessage(message, title);
  }
  

  private loadPreprodData(): void {
    try {
      const stored = localStorage.getItem("preprodInfraData");
      if (stored) {
        const parsed = JSON.parse(stored);
        // Validate structure
        if (parsed?.infraSolutionVersion && typeof parsed.infraSolutionVersion === 'string') {
          this.preprodData = parsed;
        } else {
          this.preprodData = null;
        }
      } else {
        this.preprodData = null;
      }
    } catch (error) {
      this.preprodData = null;
      // Clear corrupted data
      localStorage.removeItem("preprodInfraData");
    }
  }

   /**
 * Triggered when the version selection changes.
 * Updates the currently selected version.
 *
 * @param value - The newly selected version.
 */
onVersionChange(value){
  this.infraData = [];
  this.isVersionAvailable = false;
    if(value.minCompatibleProductVersion){
    const [currentMajor, currentMinor, currentPatch] = this.data.instance.version.split('.').map(Number);
    const [major, minor, patch] = value.minCompatibleProductVersion.split('.').map(Number);
    // if instance patch version is less than mincompatible patch version
    if(currentMajor < major || currentMinor < minor || currentPatch < patch ){
      this.title = translate('INFRA.INFRA_ALERT', { minVersion: value.minCompatibleProductVersion })
      this.showMinAlert = true;
    }
    }
    else{
      this.showMinAlert = false;
    }
    this.selectedVersion = value;
  }

  /**
 * Closes the dialog upon submit button click
 *
 * Dispatches the selected solution version
 */
  confirmSubmit() {
  const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
    panelClass: 'default-dialog-wrapper',
    width: '650px',
    autoFocus: false,
    data: {
      title: translate('INSTANCE_DETAILS.UPDATE_INFRA_VERSION'),
      message: translate('INSTANCE_DETAILS.UPDATE_INFRA_CONFIRMATION_MSG', { version: this.selectedVersion.version }),
      confirmButtonText: translate('BUTTONS.CONFIRM')
    }
  });
  confirmDialog.afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirm => {
      if (confirm) {
        this.matdialogRef.close(this.selectedVersion?.version);
      }
    });
}


checkInfraUpdates(){
 this.infraLoader = true;
 this.matdialogRef.disableClose = true;
 this.instanceService.postCheckInfraUpdates(this.data.instance.id, this.selectedVersion.version)
          .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(results => {
              if (results) {
                if (this.abortDialogRef) {
                  this.abortDialogRef.close();
                }
               this.infraLoader = false;
               this.matdialogRef.disableClose = false;
               this.infraData = results?.components;
               if(this.infraData?.length > 0){
                this.isNotInfraUpdate = false;
                this.isVersionAvailable = true;
               }else{
                 this.isNotInfraUpdate = true;
                 this.infraUpgradeMessage =  translate('INFRA.INFRA_NO_UPGRADE', { currentVersion: this.selectedVersion?.version });
               }
              }
          },
          (error) => {
             this.infraLoader = false;
             const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '342px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title: translate('INFRA.INFRA_UPDATE_TITLE'),
                  description: errorMessage
                }
        });
        });
        }

        public onCancelClick(): void {
            if (this.infraLoader) {
              this.abortDialogRef =this.dialog.open(ConfirmationDialogComponent, {
                panelClass: 'default-dialog-wrapper',
                width: '566px',
                autoFocus: false,

                data: {
                  infraWarning: true,
                  title: translate('INFRA.ABORT_TITLE'),
                  message: translate('INFRA.ABORT_MESSAGE'),
                  confirmButtonText: translate('INFRA.ABORT')
                }
              })
                this.abortDialogRef.afterClosed()
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(confirm => {
                if (confirm) {
                   this.matdialogRef.close(false);
                }
              });
            }
            else {
              this.matdialogRef.close(false);
            }
          }
}
